import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronUp } from "lucide-react";

const BTT_INITIAL = { opacity: 0, scale: 0.6, y: 12 };
const BTT_ANIMATE = { opacity: 1, scale: 1, y: 0 };
const BTT_EXIT = { opacity: 0, scale: 0.6, y: 12 };
const BTT_TRANSITION = { duration: 0.3, ease: [0.22, 1, 0.36, 1] };
const BTT_HOVER = { y: -3 };
const BTT_TAP = { scale: 0.92 };

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // Attach the scroll listener once; setState setter is stable. Intentional [].
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          aria-label="Back to top"
          title="Back to top"
          data-testid="back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          initial={BTT_INITIAL}
          animate={BTT_ANIMATE}
          exit={BTT_EXIT}
          transition={BTT_TRANSITION}
          whileHover={BTT_HOVER}
          whileTap={BTT_TAP}
          className="fixed bottom-6 right-6 z-[70] w-[46px] h-[46px] rounded-full bg-[#f5842a] text-white flex items-center justify-center shadow-[0_6px_18px_0_rgba(245,130,32,0.35),0_2px_6px_0_rgba(0,0,0,0.15)] hover:bg-[#e0761f] transition-colors duration-300"
        >
          <ChevronUp size={22} strokeWidth={2.4} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
